import type { FC, ReactNode } from 'react';
import styles from '../styles/notice-section.module.scss';

const NoticeSection: FC<{
    title: string;
    children: ReactNode;
}> = ({ title, children }) => {
    return (
        <div className={styles.noticeSection}>
            <span className={styles.noticeSectionTitle}>{title}</span>
            {children}
        </div>
    );
};

export default NoticeSection;
